// @ts-nocheck




import { createAction, createSlice } from '@reduxjs/toolkit';
import pick from 'lodash/pick';
import omit from 'lodash/omit';
import moment from 'moment';
import orderBy from 'lodash/orderBy';


import { orderApi, routeApi, orderGpmApi } from './../lib/api';
import { withCompensation } from '../lib/routeEntityCompensation';

export const SET_ORDER = 'vehicles/order/set';
export const CLEAN_ORDER = 'vehicles/order/clean';








const setOrderAction = createAction<any>(SET_ORDER);
const cleanOrderAction = createAction(CLEAN_ORDER);

const orderSlice = createSlice({
  name: 'order',
  initialState: null as any,
  reducers: {},
  extraReducers: (builder) => {
    builder.
    addCase(setOrderAction, (state, { payload }) => ({ ...payload })).
    addCase(cleanOrderAction, () => null);
  }
});

export const orderActions = {
  set: setOrderAction,
  clean: cleanOrderAction
};

/**
 * Копирование заявки
 *
 * @param orderId Id заявки
 */
export const copyOrder = (orderId, date) => async (
dispatch) =>
{
  const order = await orderApi.fetchOrder(orderId);
  const copy = pick(order, [
  'type',
  'objective',
  'employeeId',
  'notation',
  'isBusinessTrip',
  'businessTripOrderNumber',
  'businessTripDecreeNumber',
  'vehicleType',
  'vehicleGroup',
  'workersCount',
  'withTrailer',
  'route.waypoints',
  // ГПМ поля
  'isGpm',
  'mainEngineerId',
  'gpmOwnerId',
  'vehicleModelId',
  'natureOfWork',
  'object',
  'safetyResponsibles',
  'riggers',
  'secondaryRiggers',
  'project',
  'powerLinesInfo',
  'voltage',
  'vhDistance',
  'safetyZone',
  'permitInfo',
  'admission']
  );
  dispatch(
    orderActions.set({
      /**
       * Берем все необходимые поля для создания заявки
       *
       * Лучше их явно указывать, чтобы не пропустить те поля,
       * которые проставляются в процессе работы с заявкой
       */
      ...copy,
      route: {
        waypoints: order.waypoints ?
        order.waypoints.map((waypoint) => {
          const month = moment(date).month();
          const day = moment(date).date();
          const year = moment(date).year();
          // Заменяем день, год и месяц
          waypoint.arrivedDateTime = moment.
          utc(waypoint.arrivedDateTime).
          set({ month, date: day, year }).
          toISOString();
          waypoint.departureDateTime = moment.
          utc(waypoint.departureDateTime).
          set({ month, date: day, year }).
          toISOString();
          return omit(waypoint, 'id');
        }) :
        []
      }
    })
  );
};

export const addOrder = (order) => async (
dispatch) =>
{
  const addedRoute = await routeApi.addRoute(order.route);
  const newOrder = {
    ...order,
    routeId: addedRoute.id
  };
  const addedOrder = await withCompensation(
    () => order.isGpm ?
    orderGpmApi.addGpmOrder(newOrder) :
    orderApi.addOrder(newOrder),
    () => routeApi.deleteRoute(addedRoute.id)
  );
  dispatch(orderActions.set({ ...addedOrder }));
  return addedOrder;
};

export const updateOrder = (order) => async (
dispatch) =>
{
  const previousRoute = await routeApi.fetchRoute(order.route.id);
  const route = await routeApi.updateRoute(order.route);
  const updatedOrder = await withCompensation(
    () => order.isGpm ?
    orderGpmApi.updateGpmOrder(order) :
    // $FlowFixMe несовместимость object и promise
    orderApi.updateOrder(order),
    () => routeApi.updateRoute(previousRoute)
  );
  const newOrder = {
    ...updatedOrder,
    route
  };
  dispatch(orderActions.set(newOrder));
  return newOrder;
};

export const fetchOrder = (orderId) => async (
dispatch) =>
{
  const order = await orderApi.fetchOrder(orderId);
  const route = await routeApi.fetchRoute(order.routeId);

  const payload = {
    ...order,
    route: {
      ...route,
      waypoints: orderBy(
        route.waypoints,
        ['arrivedDateTime', 'departureDateTime'],
        ['asc', 'asc']
      )
    }
  };

  dispatch(orderActions.set(payload));
  return payload;
};

export const cleanOrder = () => async (
dispatch) =>

dispatch(orderActions.clean());

export const changeStatus = (id, options) => async (
dispatch) =>
{
  await orderApi.changeStatus({ ...options, id });
  const order = await orderApi.fetchOrder(id);
  const route = await routeApi.fetchRoute(order.routeId);
  dispatch(
    orderActions.set({
      ...order,
      route
    })
  );
};

export default orderSlice.reducer;
